<template>
  <div class="order-card-wrapper">
    <div class="order-title">
      <div class="order-title-text">
        <span class="title">{{ list.title }}</span>
        <span class="orderid">{{ list.order_id }}</span>
      </div>
      <div class="order-price">
        <span v-if="list.is_type === 1">-{{ list.balance }}</span>
         <span v-if="list.is_type === 2">+{{ list.balance }}</span>
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  name: 'BalanceList',

  props: {
    list: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'expenditure',
    },
  },
  
  data() {
    return {};
  },
  
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";
.order-card-wrapper {
  background-color: #fff;
  margin-bottom: 15px;
  border-radius: .5rem;
  overflow:hidden;
  padding:0rem 1rem;
}

.order-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  color: rgb(51, 51, 51);
  font-family: PingFang SC;
  font-weight: 500;
  border-bottom: 1px solid #f1f1f1;
 
  .order-title-text {
   
    flex: 3;
    @include text-ellipsis();
    .title{
        display: block;
         font-size: 14px;
    }
    .orderid{
      color:#7d7d7d;
        font-size: 12px;
    }
  }
  
  .order-price {
    font-size: 16px;
    color: #f40;
  }
}



</style>
